export let Ingredient = {
};

export const updateIngredient = (ingredients) => {
  Ingredient = ingredients;
}

export let Price = {
};

export const updatePrice = (price) => {
  Price = price;
}